import { enums } from "../../../../shim/jsbridge";
import {
  RLCSHistoryAnalysis,
  RLCSPageData
} from "../../@types/rldynamicanalysis/";
import { INITIAL_ANALYSIS_SELECTIONS } from "../reanalyze/reanalyze-popup/consts";

export const createDroppedFilesActionDisabledMessage = (
  isStoredReport: boolean,
  hasDroppedFiles: boolean | undefined
) => {
  if (isStoredReport)
    return "Download not available for locally stored reports.";
  if (hasDroppedFiles === false)
    return "Dropped files no longer available. Reprocessing the file generates new artifacts.";
  return "";
};

export const getDownloadDroppedFilesDisabledMessage = (
  isStored: boolean,
  hasDroppedFiles: boolean | undefined,
  isPrivate: boolean | undefined,
  isLoading: boolean,
  sourceId?: number | string
) => {
  if (isPrivate)
    return "Cannot send dropped files to static analysis for private samples.";
  if (isLoading) return "Analysis for current sample in progress.";
  if (isStored)
    return "Dropped files static analysis is not available for locally stored reports.";
  if (hasDroppedFiles === false)
    return "Dropped files no longer available. Reprocessing the file generates new artifacts.";
  if (!sourceId)
    return "Fetch and Analyze sample to proceed with dropped files static analysis.";
  return "";
};

export const getTabDataCounts = (data: RLCSPageData) => {
  const { dynamic_analysis_routes: dynamicAnalysisTabs } = enums || {};
  const {
    network,
    dropped_files,
    process_tree,
    mitre_attack,
    snort_alerts,
    sigma_detections,
    suricata_alerts,
    malware_configurations,
    signatures,
    yara,
    android_behavioral,
    apk
  } = data || {};

  const networkCount = network
    ? Object.values(network).reduce(
        (totalNetworkItems, currentNetworkItem) =>
          totalNetworkItems + currentNetworkItem.length,
        0
      )
    : 0;

  const mitreCount = mitre_attack
    ? mitre_attack?.Enterprise?.reduce(
        (totalMitreCount, currentMitreColumn) =>
          totalMitreCount + currentMitreColumn.techniques.length,
        0
      )
    : 0;

  const malwareConfigCount =
    malware_configurations?.configurations?.length || 0;

  const dataCounts = {
    [dynamicAnalysisTabs.SIGNATURES]: signatures?.length || 0,
    [dynamicAnalysisTabs.MALWARE_CONFIGURATIONS]: malwareConfigCount,
    [dynamicAnalysisTabs.NETWORK_ANALYSIS]: networkCount,
    [dynamicAnalysisTabs.SIGMA_DETECTIONS]: sigma_detections?.length || 0,
    [dynamicAnalysisTabs.BEHAVIORAL]: process_tree?.length || 0,
    [dynamicAnalysisTabs.DROPPED_FILES]: dropped_files?.length || 0,
    [dynamicAnalysisTabs.MITRE_ATTACK]: mitreCount,
    [dynamicAnalysisTabs.SURICATA_ALERTS]:
      (suricata_alerts?.length || 0) + (snort_alerts?.length || 0),
    [dynamicAnalysisTabs.YARA]: yara?.length || 0,
    [dynamicAnalysisTabs.ANDROID_BEHAVIORAL]:
      (android_behavioral?.permissions?.length || 0) +
      (android_behavioral?.dynamic_services?.length || 0) +
      (android_behavioral?.dynamic_receivers?.length || 0),
    [dynamicAnalysisTabs.APK]: apk?.length || 0
  };
  return dataCounts;
};

export const INITIAL_ANALYSIS_SELECTIONS_WITH_RLCS = {
  ...INITIAL_ANALYSIS_SELECTIONS,
  rl_dynamic_analysis: true
};

export const getLatestFinishedAnalysis = (
  historyAnalysis?: RLCSHistoryAnalysis[]
) => (historyAnalysis ?? []).find(analysis => Boolean(analysis.classification)); // finished analysis has classification set
